export enum AutoLoginError {
  TokenError = 'token_error',
}
